import { render, staticRenderFns } from "./contract-preparation.vue?vue&type=template&id=8a477d3c&scoped=true"
import script from "./contract-preparation.vue?vue&type=script&lang=js"
export * from "./contract-preparation.vue?vue&type=script&lang=js"
import style0 from "./contract-preparation.vue?vue&type=style&index=0&id=8a477d3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a477d3c",
  null
  
)

export default component.exports